"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSmartPlasticsModel = void 0;
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const echain_product_models_1 = require("@igus/echain-product-models");
const isSmartPlasticsModel = (whatever) => {
    const possibleSmartPlasticsModel = whatever;
    return ((0, echain_shared_ts_utils_1.isDefinedObject)(possibleSmartPlasticsModel) &&
        possibleSmartPlasticsModel.ArticleType === echain_product_models_1.ArticleType.zubehoer &&
        Boolean(possibleSmartPlasticsModel.smartPlasticsType));
};
exports.isSmartPlasticsModel = isSmartPlasticsModel;
//# sourceMappingURL=SmartPlasticsModel.js.map